module.exports = require('./prodFront');